@if (visible) {
  <div
    class="maintenance-alert"
    [class.maintenance-alert--login]="layout === 'login'"
    [class.maintenance-alert--home]="layout === 'home'"
    role="alert">
    <div class="maintenance-alert__content">
      <span class="maintenance-alert__icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" focusable="false">
          <path d="M12 22a2.5 2.5 0 0 0 2.45-2h-4.9A2.5 2.5 0 0 0 12 22Zm7-6v-5a7 7 0 0 0-5.5-6.84V3.5a1.5 1.5 0 0 0-3 0v.66A7 7 0 0 0 5 11v5l-2 2v1h18v-1l-2-2Z" />
        </svg>
      </span>
      <div class="maintenance-alert__copy">
        <div class="maintenance-alert__title">SCHEDULED MAINTENANCE - August 8</div>
        <div class="maintenance-alert__description">
          BarCloud will be temporarily unavailable from 1:00 AM to 4:00 AM EST.
        </div>
      </div>
      @if (!maintenanceStarted) {
        <div class="maintenance-alert__countdown">
          <span>{{ days }}d</span>
          <span>{{ hours }}h</span>
          <span>{{ minutes }}m</span>
          <span>{{ seconds }}s</span>
        </div>
      }
      @if (maintenanceStarted) {
        <div class="maintenance-alert__started">
          Maintenance is in progress or has been completed.
        </div>
      }
    </div>
    @if (dismissible) {
      <button
        type="button"
        class="maintenance-alert__close"
        aria-label="Close maintenance alert"
      (click)="close()">&times;</button>
    }
  </div>
}
